import { useState, useEffect } from "react";
import {
  TextField,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  CircularProgress,
  Button,
  Box,
  Tooltip,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import InfoIcon from "@mui/icons-material/Info"; // Import InfoIcon

import {
  add_default_settings_for_admin,
  get_default_settings_for_admin,
} from "../../DAL/adminAuth/auth";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

export default function DefaultSetting() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingForm, setIsLoadingForm] = useState(true);

  const [inputs, setInputs] = useState({
    cc_email: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const fetchSettings = async () => {
    setIsLoadingForm(true);
    const result = await get_default_settings_for_admin();
    console.log(result, "resultresultresultresult");

    if (result.code === 200) {
      const setting = result?.admin_portal_settings;
      setInputs({
        cc_email: setting?.cc_email,
      });
      setIsLoadingForm(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoadingForm(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const fprmData = new FormData();
    fprmData.append("cc_email", inputs.cc_email);

    // const postData = {
    //   payment_settings: { ...inputs },
    // };
    const result = await add_default_settings_for_admin(fprmData);

    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchSettings();
  }, []);

  if (isLoadingForm) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <div className="container-fluid">
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-12">
            <h4>Default Setting</h4>
          </div>

          <div className="col-12 col-md-6 mt-3">
            <Box className={classes.textFieldWithIcon}>
              <TextField
                label="CC Email"
                name="cc_email"
                type="email"
                value={inputs.cc_email}
                onChange={handleChange}
                variant="outlined"
                fullWidth
                required
                InputProps={{
                  // Add InputProps here
                  endAdornment: (
                    <InputAdornment position="end">
                      <Tooltip
                        title="When a user submits a case, an email is sent to the assigned attorney. A copy of the email will also be sent to the CC email provided here.
 "
                      >
                        <IconButton aria-label="info about CC Email" edge="end">
                          <InfoIcon color="action" />
                        </IconButton>
                      </Tooltip>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </div>

          <div className="text-end mt-4">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={isLoading}
            >
              {isLoading ? "Updating..." : "Update"}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}
